import { UserType } from '../../entities/tenant/user.type';
import { AppSecurityRight } from '../modules/app.security';
import { AssetSecurityModule } from '../modules/asset.security.module';
import { ClaimSecurityRight } from '../modules/claim.security.module';
import { ConfigurationSecurityRight } from '../modules/configuration.security.module';
import { withDerivedCrmRecordRights } from '../modules/crm.record.rights';
import { CrmSecurityRight } from '../modules/crm.security.module';
import { DashboardSecurityRight } from '../modules/dashboard.security.module';
import { DefectSecurityModule } from '../modules/defect.security.module';
import { JobSecurityModule, JobSecurityRight } from '../modules/job.security.module';
import { withDerivedJobSectionRights } from '../modules/job.section.rights';
import { JobTemplateSecurityRight, JobTemplatesSecurityModule } from '../modules/job.template.security.module';
import { MobileTechniciansSecurityRight } from '../modules/mobile.technicians.security.module';
import { SalesSecurityModule, SalesSecurityRight } from '../modules/sales.security.module';
import { QuoteTemplatesSecurityModule } from '../modules/quote.template.security.module';
import { RecurringJobSecurityModule } from '../modules/recurring.job.security.module';
import { TaskSecurityRight } from '../modules/task.security.module';
import { TimesheetSecurityRight } from '../modules/timesheet.security.module';
import { VariationSecurityModule } from '../modules/variation.security.module';
import { WorkComplianceSecurityRight } from '../modules/work.compliance.security.module';
import { SecurityRole, SecurityRoleType } from '../security.role';

export class EmployeeOperations implements SecurityRole {

    _id = 'f4c5d7c6-dc9c-44b9-97f7-a1a1400a4e50';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeOperations;
    type = UserType.Employee;
    description = 'Can manage customers, generate invoices and edit pricebooks';

    rights = withDerivedCrmRecordRights(withDerivedJobSectionRights([
        AppSecurityRight.LoginWeb,

        ConfigurationSecurityRight.AccessMetadata,
        ConfigurationSecurityRight.AccessPricing,
        ConfigurationSecurityRight.AccessTemplates,

        ConfigurationSecurityRight.ManageMetadata,
        ConfigurationSecurityRight.ManagePricing,
        ConfigurationSecurityRight.ManageTemplates,

        ConfigurationSecurityRight.AccessDocumentThemes,
        ConfigurationSecurityRight.ManageDocumentThemes,

        WorkComplianceSecurityRight.ManageCompliance,
        WorkComplianceSecurityRight.ManageComplianceRules,



        // MarkFinanceLock excluded: marking a job or stage Non-Billable / Non-Payable zeroes every line
        // under it, so it ships granted to no seeded role and a consultant enables it per role.
        // ChangeJobStructure excluded: a job's structure decides its stages and scheduling, so only an
        // administrator overrides or converts it by default and a consultant enables it per role.
        ...new JobSecurityModule().allExceptRights([JobSecurityRight.ModifyJobAfterFinalise, JobSecurityRight.ReverseWorkOrderStatus, JobSecurityRight.AccessQuote, JobSecurityRight.ManageQuote, JobSecurityRight.ModifyLockedItems, JobSecurityRight.MarkFinanceLock, JobSecurityRight.ApprovePendingItems, JobSecurityRight.ChangeJobStructure, JobSecurityRight.CompleteStagesWithUnresolvedTasks]),
        ...new VariationSecurityModule().allRights,
        ...new DefectSecurityModule().allRights,

        CrmSecurityRight.CanAccess,
        CrmSecurityRight.ManageSubcontractors,
        CrmSecurityRight.ViewRecurringJobsWithinCustomers,
        CrmSecurityRight.ViewRecurringJobsWithinSites,
        CrmSecurityRight.ViewServicesWithinSites,
        ClaimSecurityRight.AccessIncomingClaims,
        ClaimSecurityRight.ManageIncomingClaims,

        ...new AssetSecurityModule().allRights,
        ...new RecurringJobSecurityModule().allRights,
        ...new JobTemplatesSecurityModule().allRights,
        ...new QuoteTemplatesSecurityModule().allRights,
        ...new SalesSecurityModule().allExceptRights([SalesSecurityRight.DeleteOpportunity]),

        ...[TimesheetSecurityRight.CanAccess, TimesheetSecurityRight.ManageMyTimesheets],

        ...[TaskSecurityRight.CanAccess, TaskSecurityRight.ManageManualTasks, TaskSecurityRight.DeleteMyTasks, TaskSecurityRight.DeleteAnyTasks],

        // DashboardSecurityRight.CanViewSystemDashboards,
        DashboardSecurityRight.CanCreateDashboards,
    ]));

}

